<script setup>
import LoadingBlock from '@/components/global-themed/LoadingBlock.vue';
import ZeroContent from '@/components/global-themed/ZeroContent.vue';
import useActionCategories from '@/composables/useActionCategories';
import CategoryActionGroupPanel from "@/components/actions/partials/CategoryActionGroupPanel.vue";
import MoveGroupTransition from "@/components/transitions/MoveGroupTransition.vue";
import {computed, onMounted} from "vue";
import CategoryStatsCarousel from "@/components/actions/partials/CategoryStatsCarousel.vue";

const {data: categoriesData, isLoading} = useActionCategories();

const filteredCategoriesData = computed(() => {
  if (!categoriesData.value) {
    return;
  }

  return Object.values(categoriesData.value).filter(data => data.actions_count > 0);
});

onMounted(() => {
  window.mixpanel('Actions v2: View by category');
});
</script>

<template>
  <CategoryStatsCarousel
    v-if="categoriesData"
    class="tw-mb-10"
  />

  <LoadingBlock v-if="isLoading" />

  <ZeroContent v-else-if="!Object.keys(categoriesData).length">
    Looks like there are no actions to display.
  </ZeroContent>

  <MoveGroupTransition
    v-else
    class="tw-space-y-10 tw-h-[72vh] tw-overflow-y-auto visible-scrollbar"
  >
    <CategoryActionGroupPanel
      v-for="data in filteredCategoriesData"
      :key="data.category"
      :category="data.category"
      :sub-categories="data.sub_categories"
    />
  </MoveGroupTransition>
</template>
